import { useCurrentSite } from '../providers/currentSite/useCurrentSite';

import { useUrlGenerator } from './useUrlGenerator';

export type MobileApplicationStore = 'apple' | 'google';

export function useAppMobile(platform: MobileApplicationStore) {
    const { currentSite } = useCurrentSite();
    const { generateFooterMobileApplicationUrl, generateMobileApplicationUrl } = useUrlGenerator();

    const mobileApp = currentSite.mobileApp[platform];

    return {
        storeId: mobileApp.storeId,
        imagePath: mobileApp.imagePath,
        footerUrl: generateFooterMobileApplicationUrl(platform),
        storeUrl: generateMobileApplicationUrl(platform),
    };
}
